import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/*************************************************************************************
 *   Used to compare a control's text value to a string array to verify uniqueness.
 *   Assumes check is only to be performed on dirty control.
 *   Map relevant field from complex Object for this call as necessary, e.g.
 *      UniqueStringValueValidator(this.people.map(p => p.name)...)
 *   Display error message using ValidationMessagesComponent from @sd-portal/shared/util
 */
export function UniqueStringValueValidator(
  _sourceArray: string[],
  errMsgPrefix: string = 'Values'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let isUnique = true;
    if (control && _sourceArray && _sourceArray.length > 0 && control.value) {
      const controlValue = control.value as string;
      isUnique = !_sourceArray.some(
        element => element.trim().toLowerCase() === controlValue.trim().toLowerCase()
      );
    }

    return control.dirty && !isUnique ? { customMessage: errMsgPrefix + ' must be unique' } : null;
  };
}
